module.exports = __webpack_public_path__ + "static/media/color1@2x.04cd0df1.png";